module.exports = __webpack_public_path__ + "img/serial-number-tag.8be57c44.svg";